import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as At } from '../assets/svg/at.svg';
import { ReactComponent as Eye } from '../assets/svg/eye.svg';
import { ReactComponent as EyeLock } from '../assets/svg/eye-lock.svg';
import { ReactComponent as Phone } from '../assets/svg/phone.svg';
import Button from './Button';
import Notification from './Notification';
import Input from './Input';
import { Link } from 'react-router-dom';
import UserAPI from '../apis/UserAPI';
import { isValidEmail } from '../helpers/validators';

const Register = () => {
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordRepeated, setPasswordRepeated] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  const register = () => {
    if (loading) return;

    setLoading(true);

    const sanitized = {
      name: name.trim(),
      lastname: lastname.trim(),
      phone: phone.replace(/\D/g, ''),
      email: email.replace(/\s/g, '').toLowerCase(),
      password,
      passwordRepeated,
    };

    let notification = null;
    if (sanitized.name === '') notification = 'Tu nombre es incorrecto.';
    else if (sanitized.lastname === '')
      notification = 'Tus apellidos son incorrectos.';
    else if (sanitized.phone === '')
      notification = 'El celular o teléfono fijo es incorrecto.';
    else if (!isValidEmail(sanitized.email))
      notification = 'El correo es inválido.';
    else if (sanitized.password === '')
      notification = 'La contraseña es incorrecta.';
    else if (sanitized.passwordRepeated === '')
      notification = 'No has completado el campo de "Repita la contraseña".';
    else if (sanitized.password !== sanitized.passwordRepeated)
      notification = 'Las contraseñas no coinciden.';
    else if (
      !(sanitized.password.length > 3 && sanitized.password.length < 21) ||
      !(
        sanitized.passwordRepeated.length > 3 &&
        sanitized.passwordRepeated.length < 21
      )
    )
      notification = 'Tu contraseña debe tener entre 4 y 20 caracteres.';

    if (notification) {
      setNotification(notification);
      setLoading(false);
    } else {
      setNotification(null);
      UserAPI.register(
        sanitized.email,
        sanitized.password,
        sanitized.name,
        sanitized.lastname,
        sanitized.phone
      ).catch((error) => {
        setNotification(error);
        setLoading(false);
      });
    }
  };

  return (
    <Container>
      <Wrapper>
        <Title>Únete</Title>
        {notification && <NotificationStyled message={notification} />}
        <InputStyled
          maxLength={50}
          placeholder='Nombre'
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InputStyled
          maxLength={50}
          placeholder='Apellidos'
          value={lastname}
          onChange={(e) => setLastname(e.target.value)}
        />
        <InputStyled
          maxLength={50}
          placeholder='Celular o teléfono fijo'
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          icon={<InputIcon as={Phone} />}
        />
        <InputStyled
          maxLength={50}
          placeholder='Correo'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={<InputIcon as={At} />}
        />
        <InputStyled
          placeholder='Contraseña'
          autocomplete='new-password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={showPassword ? 'text' : 'password'}
          icon={
            password.length > 0 && (
              <InputIcon
                button
                as={showPassword ? EyeLock : Eye}
                onClick={() => setShowPassword((state) => !state)}
              />
            )
          }
        />
        <InputStyled
          placeholder='Repita la contraseña'
          autocomplete='new-password'
          value={passwordRepeated}
          onChange={(e) => setPasswordRepeated(e.target.value)}
          type={showPassword ? 'text' : 'password'}
          icon={
            passwordRepeated.length > 0 && (
              <InputIcon
                button
                as={showPassword ? EyeLock : Eye}
                onClick={() => setShowPassword((state) => !state)}
              />
            )
          }
        />
        <Buttons>
          <ButtonStyled
            as={ButtonLink}
            to='/login'
            text='Iniciar sesión'
            secondary
          />
          <ButtonStyled
            text='Registrarme'
            onClick={register}
            loading={loading}
            primary
          />
        </Buttons>
      </Wrapper>
    </Container>
  );
};


const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Title = styled.div`
  align-self: flex-start;
  font-size: 1.5em;
  font-weight: 600;

  margin-bottom: 25px;
`;

const NotificationStyled = styled(Notification)`
  margin: 0px 0px 20px 0px;
`;

const InputStyled = styled(Input)`
  margin-bottom: 10px;
`;

const Wrapper = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 100%;

  padding: 5px;
  box-sizing: border-box;
`;

const InputIcon = styled.div`
  padding: 8px 10px;
  min-width: 18px;
  min-height: 18px;
  width: 18px;
  height: 18px;
  margin: auto 0;
  fill: rgba(0, 0, 0, 0.5);

  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`;

const ButtonLink = (props) => <Button as={Link} {...props} />;

const ButtonStyled = styled(Button)`
  margin: 15px 0px;
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export default Register;
